module.exports = __webpack_public_path__ + "static/media/tv-box.1f41d033.png";